import React from 'react';
import './AmenityOptions.css';

const AmenityOptions = (props) => {
    const { options } = props;

    console.log('AmenityOptions props:', props);

    const handleOptionClick = (optionId) => {
        console.log('Button clicked, optionId:', optionId);

        // First, add the user's selection as a message in the chat
        if (props.setState) {
            const userMessage = props.createChatBotMessage
                ? { ...props.createChatBotMessage(optionId), type: 'user' }
                : {
                    type: 'user',
                    message: optionId,
                    id: Date.now()
                };

            props.setState((prev) => ({
                ...prev,
                messages: [...prev.messages, userMessage]
            }));
        }

        // Then trigger the API call using the global handler
        if (window.chatbotActionHandler) {
            console.log('Calling API with optionId:', optionId);
            window.chatbotActionHandler(optionId);
            return;
        }

        console.error('Global chatbotActionHandler not available');
    };

    return (
        <div className="amenity-options-container">
            {options.map((option) => (
                <button
                    key={option.option_id}
                    className="amenity-option-button"
                    onClick={() => handleOptionClick(option.option_id)}
                >
                    {option.name}
                </button>
            ))}
        </div>
    );
};

export default AmenityOptions;
